import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import useUserStore from './modules/user'
import useCounterStore from './modules/counter'
import useRouteCacheStore from './modules/routeCache'
import useUIStore from './modules/ui'
import { useActivityStore } from './modules/activity'
import { useAppStore } from './modules/app'
import { useMessageStore } from './modules/message'
import { useRewardStore } from './modules/reward'
import { useVipStore } from './modules/vip'
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

export { useUserStore, useCounterStore, useRouteCacheStore, useUIStore, useActivityStore, useAppStore, useMessageStore, useRewardStore, useVipStore }
export default pinia
